export const getSubjects = (t: any) => {
    // Mathématiques, Français, Langue Nationale Mathématiques, Langue Nationale Lecture-Ecriture
    return [
        {value: 'Math', label: t('subjects.math')}, 
        {value: 'French', label: t('subjects.french')},
        {value: 'Science', label: t('subjects.science')}, 
        {value: 'Geometry', label: t('subjects.geometry')}, 
        {value: 'Algebra', label: t('subjects.algebra')}, 
        {value: 'Pre-numerical Activities', label: t('subjects.preNumericalActivities')}, 
        {value: 'Measurement', label: t('subjects.measurement')}, 
        {value: 'Topology', label: t('subjects.topology')}, 
        {value: 'Numeration', label: t('subjects.numeration')}, 
        {value: 'Operations', label: t('subjects.operations')}, 
        {value: 'Language', label: t('subjects.language')}, 
        {value: 'Reading', label: t('subjects.reading')}, 
        {value: 'Writing', label: t('subjects.writing')}, 
        {value: 'English', label: t('subjects.english')}, 
        {value: 'History', label: t('subjects.history')}, 
        {value: 'National Languages', label: t('subjects.nationalLanguages')}, 
        {value: 'Art', label: t('subjects.art')}, 
        {value: 'Music', label: t('subjects.music')}, 
        {value: 'Geography', label: t('subjects.geography')},
        {value: 'Physical Education', label: t('subjects.physicalEducation')},
        {value: 'Other', label: t('subjects.other')}
      ];
}

export const getGrades = (t: any) => {
    return [
        {value: 'K', label: t('grades.k')}, 
        {value: '1', label: t('grades.1')}, 
        {value: '2', label: t('grades.2')}, 
        {value: '3', label: t('grades.3')}, 
        {value: '4', label: t('grades.4')}, 
        {value: '5', label: t('grades.5')}, 
        {value: '6', label: t('grades.6')}, 
        {value: '7', label: t('grades.7')}, 
        {value: '8', label: t('grades.8')}, 
        {value: '9', label: t('grades.9')}, 
        {value: '10', label: t('grades.10')}, 
        {value: '11', label: t('grades.11')}, 
        {value: '12', label: t('grades.12')}
    ];
}

export const getDomains = (t: any) => {
    // Mathematics, French, National Languages Mathematics, National Languages Reading-Writing
    return [
        {value: 'Mathematics', label: t('domains.mathematics')},
        {value: 'French', label: t('domains.french')},
        {value: 'National Languages Mathematics', label: t('domains.nationalLanguagesMathematics')},
        {value: 'National Languages Reading-Writing', label: t('domains.nationalLanguagesReadingWriting')},
    ]
}